import GlassCard from "@/components/landing/GlassCard";
import { Activity, Users, GitBranch, Bell, Database, Zap, User } from "lucide-react";

const features = [
  {
    icon: <Database className="w-8 h-8" />,
    title: "Service Catalog",
    description: "Centralized registry of all your microservices and APIs. Complete visibility into your service landscape.",
  },
  {
    icon: <Activity className="w-8 h-8" />,
    title: "Health Monitoring",
    description: "Real-time monitoring with 5-minute check intervals. Track service health and uptime across all environments.",
  },
  {
    icon: <GitBranch className="w-8 h-8" />,
    title: "Dependency Visualization",
    description: "Static analysis of service relationships. Understand how your services connect and depend on each other.",
  },
  {
    icon: <User className="w-8 h-8" />,
    title: "Faster Onboarding",
    description: "New team members see every service, who owns it, what it does, and where to find the code, documentation, and monitoring dashboards.",
  },
  {
    icon: <Users className="w-8 h-8" />,
    title: "Team Management",
    description: "Organize services by teams with role-based access control. Scale your team without worrying about per-seat pricing eating your budget.",
  },
  {
    icon: <Zap className="w-8 h-8" />,
    title: "Fast Setup",
    description: "Get started in minutes, not weeks. No dedicated DevOps staff required. Developer-focused and simple.",
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="relative py-12 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="max-w-2xl mx-auto text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-space mb-4 md:mb-6">
            Built for <span className="text-foreground">Service Visibility</span>
          </h2>
          <p className="text-base md:text-lg text-muted-foreground">
            Complete visibility into your services, teams, and infrastructure. 
            Monitor health, track dependencies, and stay ahead of issues.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((feature, index) => (
            <GlassCard 
              key={feature.title} 
              className="opacity-0 animate-fade-in-up"
              hover
            >
              <div 
                className="text-primary mb-4 p-3 rounded-xl bg-primary/10 w-fit"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold font-space mb-3 text-foreground">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
